import firebase from "./../Firebase";
import { useHistory } from "react-router-dom";

const SignOut: React.FC = () => {
  const history = useHistory();
  const uid = firebase.auth().currentUser?.uid;

  const userStatusFirestoreRef = firebase.firestore().doc("/users/" + uid);

  async function signOut() {
    await firebase.auth().signOut();
    await userStatusFirestoreRef.update({ isOnline: false });
    history.push("/sign-in");
  }

  return <button onClick={signOut}>Sign out</button>;
};

export default SignOut;
